import { render, staticRenderFns } from "./DlgEventTemplateDelete.vue?vue&type=template&id=afed0cb0&scoped=true"
import script from "./DlgEventTemplateDelete.vue?vue&type=script&lang=ts"
export * from "./DlgEventTemplateDelete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afed0cb0",
  null
  
)

export default component.exports